<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: isShowLeftSidebar }"
      @click="isShowLeftSidebar = false"
    />
    <b-overlay :show="dataTableIsLoaded" rounded="sm" no-fade>
      <filters
        :options="donVis"
        :default-option.sync="donViFilter"
        :is-loaded="dataTableIsLoaded"
        @fetch-data="fetchData"
      />
    </b-overlay>
    
  </div>
</template>

<script>
/* eslint-disable */
import { BOverlay } from "bootstrap-vue";
import LayoutData from "@/layouts/LayoutData";
import Ripple from "vue-ripple-directive";

import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

import Filters from "./components/Filters.vue";

import useSetup from "./useSetup";

export default {
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    Filters,
  },
  data() {
    return {
      isWait: true,
    };
  },
  // computed: {
  //   common() {
  //     console.log("common", this.$store.state.common.common);
  //     return this.$store.state.common.common;
  //   },
  // },
  watch: {},
  methods: {
   

  },
  created() {
  },
  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    const appInfo = ref();
    headerData.value.title = "Cán bộ công chức";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;
    const totalRows = ref(0);
    const dataMeta = ref({});
    const {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      isSortDirDesc,
      sortBy,
      getDataList,
      getDonVi,
    } = useSetup();



    const donViFilter = ref(null);
    const donVis = ref([]);
    const dataTableIsLoaded = ref(false);
    getDonVi({}, (data) => {
      donVis.value = data;
      if (data && data.length > 0) {
      }
    });
    const dataTable = ref([]);
    const isShowLeftSidebar = ref(false);
    const editData = ref({
      donVi: {},
    });
    const tieuChis = ref(null);
    const fetchData = (filters) => {
      dataTableIsLoaded.value = true;
      tieuChis.value = filters;
      donViFilter.value = filters.donVi;
      // console.log("defaultDonVi", defaultDonVi);
      let condition = {
        donViId: donViFilter.value ? donViFilter.value.id : "",
        code: filters.code,
        isChildren: filters.isChildren ? filters.isChildren : false,
        trangThaiHoSoId: filters.trangThaiHoSo ? filters.trangThaiHoSo : null,
      };
      console.log("condition", condition);
      getDataList(condition, (res) => {
        dataTableIsLoaded.value = false;
        if (res != null){
          const blob = new Blob(
                  [base64ToArrayBuffer(res.fileContents)],
                  { type: "application/xlsx" }
              );
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              const fileName = res.fileDownloadName;
              link.download = fileName;
              link.click();
        }
        else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: "Lỗi khi tải file.",
            },
          });
        }
      });
    };

    const base64ToArrayBuffer = (base64) => {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    };

    const showLeftSlidebar = (data, id) => {
      isShowLeftSidebar.value = true;
      if (!data.donVi) {
        data.donVi = null;
      }
      editData.value = JSON.parse(JSON.stringify(data));
      // }
    };




    const pagination = (value) => {
      currentPage.value = value;
    };

    const perpage = (value) => {
      perPage.value = value;
    };
    const sortby = (value) => {
      sortBy.value = value;
    };

    return {
      pagination,
      perpage,
      sortby,
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      dataTableIsLoaded,

      totalRows,
      dataMeta,

      donVis,
      donViFilter,
      tieuChis,
      getDonVi,
      fetchData,
      dataTable,
      editData,

      isShowLeftSidebar,
      showLeftSlidebar,
      // reLoadDataTable,
      // removeItem,
      // fetchDanhMucData,
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
